import type { SplatErrorDetails, SplatErrorJSON } from '@/plugins/gsplat/types/ErrorTypes'

/**
 * Splat错误代码枚举
 * 用于分类和识别不同类型的错误
 */
export enum SplatErrorCode {
  // ========= 解析错误 =========
  /** PLY Header格式无效 */
  INVALID_PLY_HEADER = 'INVALID_PLY_HEADER',
  /** 缺少必需属性 */
  MISSING_PROPERTY = 'MISSING_PROPERTY',
  /** 二进制数据无效 */
  INVALID_BINARY_DATA = 'INVALID_BINARY_DATA',
  /** 不支持的文件格式 */
  UNSUPPORTED_FORMAT = 'UNSUPPORTED_FORMAT',

  // ========= 资源错误 =========
  /** 纹理尺寸超出限制 */
  TEXTURE_SIZE_EXCEEDED = 'TEXTURE_SIZE_EXCEEDED',
  /** 内存不足 */
  OUT_OF_MEMORY = 'OUT_OF_MEMORY',
  /** Worker线程错误 */
  WORKER_ERROR = 'WORKER_ERROR',

  // ========= WebGL错误 =========
  /** WebGL不支持 */
  WEBGL_NOT_SUPPORTED = 'WEBGL_NOT_SUPPORTED',
  /** Shader编译错误 */
  SHADER_COMPILE_ERROR = 'SHADER_COMPILE_ERROR',
  /** 浮点纹理不支持 */
  FLOAT_TEXTURE_NOT_SUPPORTED = 'FLOAT_TEXTURE_NOT_SUPPORTED',
}

/**
 * Splat错误类
 * 扩展标准Error，增加错误代码和详细信息
 */
export class SplatError extends Error {
  /** 错误代码 */
  public readonly code: SplatErrorCode
  /** 详细错误信息（可选） */
  public readonly details?: SplatErrorDetails

  /**
   * 构造函数
   * @param code 错误代码
   * @param message 错误消息
   * @param details 详细信息（可选）
   */
  constructor(code: SplatErrorCode, message: string, details?: SplatErrorDetails) {
    super(`[ThreeGS:${code}] ${message}`)
    this.name = 'SplatError'
    this.code = code
    this.details = details

    // 恢复原型链（TypeScript继承Error的已知问题）
    Object.setPrototypeOf(this, SplatError.prototype)
  }

  /**
   * 转换为 JSON 格式，用于日志记录和调试。
   *
   * @returns 结构化错误对象，包含 name/code/message/details/stack
   */
  toJSON(): SplatErrorJSON {
    return {
      name: this.name,
      code: this.code,
      message: this.message,
      details: this.details,
      stack: this.stack,
    }
  }
}
